// Generated by CoffeeScript 2.7.0
var Base, FIELD_ICONS, FIELD_TITLES;

import BaseModel from '../base_model.js';

FIELD_ICONS = {
  'TextField': 'slp-single-line-text',
  'TextArea': 'slp-multiple-lines-text',
  'Integer': 'slp-integer-circle-o',
  'IDNumber': 'slp-id-card-o',
  'Phone': 'slp-phone-o',
  'RadioButton': 'slp-circle-o',
  'CheckBox': 'slp-square-o',
  'DateTime': 'slp-date-time',
  'CascadedSelect': 'fa-sitemap',
  'File': 'fa-cloud-upload',
  'Rating': 'slp-star',
  'Organization': 'fa-users',
  'Member': 'slp-user-o',
  'Location': 'slp-map-marker',
  'Detail': 'fa-list-alt',
  'Calculation': 'slp-function',
  'SectionBreak': 'slp-text-square',
  'Esignature': 'slp-pencil-square'
};

FIELD_TITLES = {
  'TextField': '单行文本',
  'TextArea': '多行文本',
  'Integer': '数字',
  'IDNumber': '身份证号',
  'Phone': '手机号',
  'RadioButton': '单选',
  'CheckBox': '多选',
  'DateTime': '日期时间',
  'CascadedSelect': '级联选择',
  'File': '文件上传',
  'Rating': '星级评分',
  'Organization': '组织选择',
  'Member': '成员选择',
  'Location': '地理位置',
  'Detail': '明细清单',
  'SectionBreak': '章节',
  'Page': '',
  'Calculation': '计算字段',
  'Esignature': '电子签字'
};

export default Base = (function() {
  class Base extends BaseModel {
    static resolveTypedAttributes(attributes, _from_field_type) {
      delete attributes.settings.input_type;
      delete attributes.options;
      delete attributes.other_option;
      delete attributes.data.execed_js;
      return attributes;
    }

    constructor(attrs = {}, logic_settings = {}, fieldable) {
      super(attrs);
      if (!_.contains(this.availableLayouts, attrs.settings.layout)) {
        delete attrs.settings.layout;
      }
      this.settings = _.extend({}, {
        layout: this.availableLayouts[0]
      }, attrs.settings);
      this.data = _.extend({}, attrs.data);
      this.fieldable = fieldable;
      this.logicable = _.contains(['RadioButton', 'Integer', 'Rating', 'CheckBox'], attrs.type.demodulize());
      this.logic_rule = logic_settings[this.id];
      if (this.validations == null) {
        this.validations = [];
      }
    }

    changeType(to_field_type, specified_attributes = {}) {
      var field_attrs, new_field;
      field_attrs = this.toJSON();
      delete field_attrs.uuid;
      if (!this.title) {
        delete field_attrs.title;
      }
      field_attrs = this.constructor.constantize(to_field_type).resolveTypedAttributes(field_attrs, specified_attributes, this.constructor);
      field_attrs.type = to_field_type;
      new_field = this.constructor.new(field_attrs, void 0, this.fieldable);
      new_field.logic_rule = this.logic_rule;
      return new_field;
    }

    getTypeIcon() {
      return FIELD_ICONS[this.type.demodulize()];
    }

    getTypeDefaultTitle() {
      return FIELD_TITLES[this.type.demodulize()];
    }

    isTypeOf(type = 'TextField') {
      return new RegExp(type).test(this.type);
    }

    toJSON() {
      return _.extend(super.toJSON(), {
        title: this.title || this.getTypeDefaultTitle()
      });
    }

  };

  Base.setAttributes([
    'title',
    'description',
    'type',
    'position',
    'identity_key',
    'placeholder',
    'validations',
    {
      visibility: 'public_visibility'
    },
    'disabled',
    'marked',
    'remark',
    'value_cache',
    'settings',
    'data',
    'detail_id'
  ]);

  Base.prototype.availableLayouts = ['block', 'inline'];

  return Base;

}).call(this);
